import { styled } from '@mui/system';
import background from '../../../src/assets/images/resetpasswordpage-background.png';
import { useFormik } from 'formik';
import { resetPasswordSchema } from '../../schemas/auth.request';
import { useEmailResetPasswordMutation } from '../../store/api/userApi';
import Loading from '../../components/ui/Loading';
import EnterNewPassword from './components/EnterNewPassword';
import ConfirmMessage from './components/ConfirmMessage/ConfirmMessage';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const ResetPasswordPageContainer = styled('div')({
  width: '100%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundImage: `url(${background})`,
});

const ResetPasswordPageWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.54)',
});

const validate = (values) => {
  const errors = {};
  const valid = resetPasswordSchema.validate(values, { abortEarly: false });
  if (valid.error) {
    valid.error.details.forEach((err) => {
      errors[err.path.join('.')] = err.message;
    });
  }
  return errors;
};

const EmailResetPasswordPage = () => {
  const [emailResetPassword, { isLoading, isSuccess, isError, error }] =
    useEmailResetPasswordMutation();
  function extractIdFromURL(url) {
    const values = url.split('/');
    return values[3];
  }
  function extractTokenFromURL(url) {
    const values = url.split('/');
    return values[4];
  }
  const location = useLocation();
  const currentId = extractIdFromURL(location.pathname);
  const currentToken = extractTokenFromURL(location.pathname);

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validate,
    onSubmit: async (values, { resetForm }) => {
      await emailResetPassword({ id: currentId, token: currentToken, password: values.password });
      resetForm();
    },
  });

  if (isLoading) return <Loading />;

  if (isError) {
    toast.error(error.data.error, { toastId: 'error' });
  }

  return (
    <ResetPasswordPageContainer>
      <ResetPasswordPageWrapper>
        {isSuccess ? <ConfirmMessage /> : <EnterNewPassword formik={formik} />}
      </ResetPasswordPageWrapper>
    </ResetPasswordPageContainer>
  );
};

export default EmailResetPasswordPage;
